export function stripQuery(url) {
  return typeof url === "string" ? url.split("?")[0] : url;
}

export function scrubEvent(event) {
  if (event.request?.url) {
    event.request.url = stripQuery(event.request.url);
  }

  if (event.request?.query_string) {
    delete event.request.query_string;
  }

  if (event.request?.headers?.Referer) {
    event.request.headers.Referer = stripQuery(event.request.headers.Referer);
  }

  if (event.request?.headers?.referer) {
    event.request.headers.referer = stripQuery(event.request.headers.referer);
  }

  return event;
}

export function scrubBreadcrumb(breadcrumb) {
  if (breadcrumb.data?.url) {
    breadcrumb.data.url = stripQuery(breadcrumb.data.url);
  }

  if (breadcrumb.data?.from) {
    breadcrumb.data.from = stripQuery(breadcrumb.data.from);
  }

  if (breadcrumb.data?.to) {
    breadcrumb.data.to = stripQuery(breadcrumb.data.to);
  }

  return breadcrumb;
}
